var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"card"}},[_c('div',{staticClass:"page"},[_c('add-card',{on:{"add-card":_vm.addCard}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }